module.exports = __webpack_public_path__ + "static/media/03.bc57cd58.png";